import { Tabs } from '@design-systems/canvas-ui'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

type TeamTab = {
  name: 'Teams' | 'Find a user'
  url: string
}

const tabMenuData: TeamTab[] = [
  {
    name: 'Teams',
    url: '/teams',
  },
  {
    name: 'Find a user',
    url: '/users',
  },
]

const TeamsTabs: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const activeTab = location.pathname.includes('/users')
    ? 'Find a user'
    : 'Teams'

  return (
    <Tabs disableAdaptive activeTab={activeTab}>
      {tabMenuData.map((tab) => (
        <Tabs.Item
          name={tab.name}
          data-test={'tabs' + tab.name}
          key={tab.name}
          onClick={() => {
            navigate(tab.url)
          }}
        >
          {tab.name}
        </Tabs.Item>
      ))}
    </Tabs>
  )
}

export default TeamsTabs
